
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { AuthProvider } from "../Components/AuthProvider";

import PrivatePublicRoute from "./PrivatePublicRoute";
import RegisterComponent from "../Pages/RegisterComponent";



const RoutesPage = () => {
    return (
        <>
            <AuthProvider>
                <Router>
                    <Routes>
                        {/* public routes */}
                        <Route element={<PrivatePublicRoute />}>
                            <Route path="/" element={<RegisterComponent />}></Route>

                        </Route>

                    </Routes>
                </Router>
            </AuthProvider>
        </>
    )
}

export default RoutesPage